<template>
    <div :class="format" >
        <multiselect
                v-model="tags"
                @input="$emit('input', tags)"
                :placeholder="placeholder"
                :tag-placeholder="tagPlaceholder"
                :taggable="true"
                label="name"
                track-by="id"
                :options="opts"
                :multiple="multiple"
                :close-on-select="closeOnSelect"
                :clear-on-select="clearOnSelect"
                :hide-selected="true"
                :loading="loading"
                :disabled="loading"
                @tag="addTag"
                :max=5
                :options-limit=5
                :internal-search="true"
                style="min-height: 20px">
           
           <template slot="option" slot-scope="props">
                <span class="text-capitalize">{{ props.option.name }}</span>
            </template>

            <template slot="tag" slot-scope="props">
                <span class="badge badge-pill tag-pill text-capitalize badge-primary px-2 py-2 mr-1 "
                      style="padding-left: 12px !important;">{{  formaterTag(props.option.name) }} <i
                        @click.prevent.stop="props.remove(props.option)" class="fa fa-times tag-remove ml-1"></i></span>
            </template>

 
        </multiselect>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
    .default {
        ::v-deep {

            .multiselect {
                min-height: 20px !important;
            }
            .multiselect__tags {
                min-height: 20px !important;
                padding: 0 !important;
                border: 1px solid transparent !important;
                box-shadow: none !important;
                
            }
            .multiselect__select {
                min-height: 20px !important;
                height: 26px !important;
            }
            .multiselect__content-wrapper {
                box-shadow: 0px 5px 20px -5px #444 !important;
            }
            .multiselect__option--highlight, .multiselect__option--highlight:after {
                background-color: #0374d7 !important;
            }
            .multiselect__input {
                margin-bottom: 0 !important;
                padding-top: 3px !important;
            }

            .tag-pill {
                margin: 2px 2px 2px 0;
                font-size: 12px;
                font-weight: 100;
            }
            .tag-remove {
                padding: 3px;
                margin: -4px;
                border-radius: 50%;
                width: 17px;
                height: 17px;
                background-color: rgba(0, 0, 0, 0);
                transition: all 0.15s ease-in-out;
                cursor: pointer;
                &:hover {
                    background-color: rgba(0, 0, 0, 0.1);
                }
            }
        }
    }

</style>

<script>
    import Multiselect from 'vue-multiselect';

    export default {
        components: {Multiselect},

        props: {
            value         : {required: true},
            options       : {default: () => []},
            placeholder   : {required: false, type: String, default: 'Add or Remove Tags'},
            tagPlaceholder: {required: false, type: String, default: 'Add this as new tag'},
            type          : {required: false, type: String, default: ''},
            format        : {required: false, type: String, default: 'default'},
            multiple      : {required: false, type: Boolean, default: () => true},
            closeOnSelect : {required: false, type: Boolean, default: () => false},
            clearOnSelect : {required: false, type: Boolean, default: () => true},
            autoFetch     : {default: false},
        },

        watch: {
            value(val) {
                this.tags = val || (this.multiple ? [] : {})
            },
            options(val) {
                this.opts = val || []
            },
        },

        data() {
            return {
                loading: false,
                tags   : [],
                opts   : [],
            }
        },

        mounted() {
            this.opts = this.options || [];
            this.tags = this.value || [];
            if (!this.opts.length && this.autoFetch) {
                this.fetchTags().then(tags => this.opts = tags.data);
            }
        },

        methods: {
            addTag(tag) {

                this.loading = true;
                return this.firstOrCreate(tag).then(tag => {
                    this.loading = false;
                    this.opts.push(tag);
                    this.multiple ? this.tags.push(tag) : this.tags = tag;
                    this.$emit('input', this.tags);
                    Bus.$emit('updateInputTags');
                })
            },

            formaterTag(tag){
                if(tag.length > 30){
                    let tagAux = "";
                    let cont = 0;
                    for (var i = 0; i <= 30; i++) {
                        tagAux = tagAux+tag[i];
                    }
                    tagAux = tagAux+"...";
                    return tagAux;
                }else{
                    return tag;
                }
            },

            firstOrCreate(name) {
                let data = {name, type: this.type};
                return this.$http.post(this.$laroute.route('api.tags.store'), data).then(({data}) => data);
            },

            fetchTags() {
                return this.$http.get(this.$laroute.route('api.tags.index', {type: this.type})).then(({data}) => data);
            },
        },
    }
</script>
